import { render, staticRenderFns } from "./ChileCompraForm.vue?vue&type=template&id=264018c3&scoped=true&"
import script from "./ChileCompraForm.vue?vue&type=script&lang=ts&"
export * from "./ChileCompraForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264018c3",
  null
  
)

export default component.exports